import { Box } from '../components/Box';

export default function BusinessTerms() {
  return (
    <Box
      height="40vh"
      overflow="auto"
      padding="1.5rem"
      border="1px solid"
      borderColor="divider"
      borderRadius="20px"
      sx={{
        className: 'business-terms',
        backgroundColor: 'white',
        boxShadow:
          '0 5px 22px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.06)',
        mb: 2,
      }}
    >
      <style>
        {`
          @import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLTi9jKYd1gJzj5O2gWsEpXoyck2WCYPEMNySjZN0CHed_kmCvy597kDopqFAXvpeaA);

          .business-terms {
            background-color: #ffffff;
            max-width: 471pt;
            padding: 71.6pt 69.2pt 67.1pt 71.8pt;
            color: #000000;
            font-size: 11pt;
            font-family: "Calibri";
          }

          .section-title {
            font-weight: 700;
            text-decoration: underline;
            -webkit-text-decoration-skip: none;
            text-decoration-skip-ink: none;
          }

          .section-text {
            margin-bottom: 1em;
            line-height: 1.0223182439804077;
          }

          .text-center {
            text-align: center;
          }

          .bold {
            font-weight: 700;
          }

          .italic {
            font-style: italic;
          }

          .page-number {
            text-align: center;
            font-family: "Cambria";
            padding: 12pt 0;
          }

          .subsection {
            margin-left: 25.8pt;
            padding-top: 10.4pt;
          }
        `}
      </style>

      <h1 className="section-title text-center">
        EXERCISE.COM SAAS SUBSCRIPTION AGREEMENT
      </h1>

      <div className="section-text">
        This Exercise.com SaaS Subscription Agreement (this
        &quot;Agreement&quot;) is a legally binding contract between
        Exercise.com LLC <span className="italic bold">DBA Exercise.com</span>{' '}
        (&quot;Vendor&quot;) and an individual end user of Vendor&apos;s System,
        as defined below (&quot;You,&quot; &quot;Your&quot;). Vendor provides
        fitness business management software (the &quot;System&quot;). You agree
        that when you access or use the System, You will do so subject to this
        Agreement.{' '}
        <span className="bold">
          DO NOT ACCESS OR USE THE SYSTEM IF YOU ARE UNWILLING OR UNABLE TO BE
          BOUND BY THIS AGREEMENT.
        </span>
      </div>

      <div className="section-text">
        This Agreement is effective as of the date You click &quot;Accepted and
        Agreed To&quot; (the &quot;Effective Date&quot;).
      </div>

      <section>
        <h2 className="section-title">1. USE OF THE SYSTEM IN GENERAL.</h2>

        <div className="subsection">
          <p>
            <span className="bold">1.1. Eligibility.</span> You represent and
            warrant that You are 18 years old or older, and You recognize and
            agree that You must be 18 years old or older to use the System.
          </p>

          <p>
            <span className="bold">1.2. System Subscription.</span> During the
            Term (as defined in Section 9.1 below), You may access and use the
            System. You may reproduce and use Vendor&apos;s standard manual
            related to use of the System (the &quot;Documentation&quot;) solely
            as necessary to support use of the System.
          </p>

          <p>
            <span className="bold">1.3. System Revisions.</span> Vendor may
            revise the features and functions of the System at any time.
          </p>

          <p>
            <span className="bold">1.4. Subscription Fees.</span> You agree to
            pay Vendor the fee set forth in Your Order on the dates required
            therein. Vendor will not be required to refund fees under any
            circumstances.
          </p>
        </div>
      </section>

      <section>
        <h2 className="section-title">2. THE APPS.</h2>

        <div className="subsection">
          <p>
            <span className="bold">2.1. License.</span> If Your Order contains
            apps, Vendor hereby grants You a nonexclusive license to iOS and
            Android custom-branded apps, solely as a component of the System,
            provided You comply with the restrictions set forth below in Section
            2.2 (<span className="italic">Restrictions on Software Rights</span>
            ). You are responsible for any Apple App Store or Google Play fees
            to maintain your own required developer accounts. (&quot;Apps&quot;
            means Vendor&apos;s iOS and Android custom-branded apps. The Apps
            are a component of the System and is included in references thereto,
            except in this Article 2 and in any other provision that separately
            addresses the Apps.)
          </p>

          <p>
            <span className="bold">2.2. Restrictions on Software Rights.</span>{' '}
            Copies of the Apps created or transferred pursuant to this Agreement
            are licensed, not sold, and You receive no title to or ownership of
            any copy or of the Apps itself. Furthermore, You receive no rights
            to the Apps other than those specifically granted in Section 2.1
            above.
          </p>
        </div>
      </section>

      <div className="section">
        <h2 className="section-title underline">3. YOUR CONTENT AND PRIVACY</h2>
        <div className="subsection">
          <p>
            <span className="bold">3.1. Your Content.</span> You retain all
            right, title, and interest in and to Your Content. &quot;Your
            Content&quot; means data, information, and materials You provide
            through the System.
          </p>
          <p>
            <span className="bold">3.2. Privacy & Security.</span> Vendor will
            maintain reasonable security procedures and practices appropriate to
            the nature of Your Content.
          </p>
          <p>
            <span className="bold">3.3. Aggregate Data.</span> Vendor may use
            aggregated anonymized data derived from Your Content for research,
            development, and improvement of the System.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">
          4. YOUR RESPONSIBILITIES & RESTRICTIONS
        </h2>
        <div className="subsection">
          <p>
            <span className="bold">4.1. Account.</span> You are responsible for
            maintaining the confidentiality of Your account credentials and for
            all activities under Your account.
          </p>
          <p>
            <span className="bold">4.2. Restrictions.</span> You shall not: (a)
            license, sublicense, sell, or resell the System; (b) use the System
            for unlawful purposes; (c) interfere with System&apos;s operation.
          </p>
          <p>
            <span className="bold">4.3. Compliance.</span> You shall comply with
            all applicable laws and regulations in Your use of the System.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">5. IP & FEEDBACK</h2>
        <div className="subsection">
          <p>
            <span className="bold">5.1. IP Rights.</span> Vendor retains all
            right, title, and interest in and to the System, including all
            related intellectual property rights.
          </p>
          <p>
            <span className="bold">5.2. Feedback.</span> You grant Vendor a
            perpetual, irrevocable right to use any feedback You provide about
            the System.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">6. DISCLAIMERS</h2>
        <div className="subsection">
          <p>
            <span className="bold">6.1. Warranty Disclaimer.</span> THE SYSTEM
            IS PROVIDED &quot;AS IS.&quot; VENDOR DISCLAIMS ALL WARRANTIES,
            EXPRESS OR IMPLIED.
          </p>
          <p>
            <span className="bold">6.2. Internet Delays.</span> THE SYSTEM MAY
            BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT IN
            THE USE OF THE INTERNET.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">7. INDEMNIFICATION</h2>
        <div className="subsection">
          <p>
            You will defend, indemnify, and hold harmless Vendor from any claims
            arising from: (a) Your Content; (b) Your use of the System; or (c)
            Your violation of this Agreement.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">8. LIMITATION OF LIABILITY</h2>
        <div className="subsection">
          <p>
            VENDOR&apos;S TOTAL LIABILITY ARISING OUT OF OR RELATED TO THIS
            AGREEMENT WILL NOT EXCEED THE AMOUNT PAID BY YOU HEREUNDER IN THE 12
            MONTHS PRECEDING THE INCIDENT.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">9. TERM & TERMINATION</h2>
        <div className="subsection">
          <p>
            <span className="bold">9.1. Term.</span> This Agreement continues
            until terminated pursuant to this Section 9.
          </p>
          <p>
            <span className="bold">9.2. Termination.</span> Either party may
            terminate this Agreement upon 30 days written notice.
          </p>
          <p>
            <span className="bold">9.3. Effect.</span> Upon termination, You
            shall cease all use of the System.
          </p>
        </div>
      </div>

      <div className="section">
        <h2 className="section-title underline">10. MISCELLANEOUS</h2>
        <div className="subsection">
          <p>
            <span className="bold">10.1. Entire Agreement.</span> This Agreement
            constitutes the entire agreement between the parties.
          </p>
          <p>
            <span className="bold">10.2. Governing Law.</span> This Agreement is
            governed by the laws of the State of Florida.
          </p>
          <p>
            <span className="bold">10.3. Assignment.</span> You may not assign
            this Agreement without Vendor&apos;s prior written consent.
          </p>
          <p>
            <span className="bold">10.4. Severability.</span> If any provision
            is held invalid, the remaining provisions will continue in full
            force and effect.
          </p>
        </div>
      </div>

      <div className="page-number">6</div>

      <div className="section-text company-info">
        Vendor: Oak 18 Ventures LLC DBA Exercise.com
        <br />
        15310 Amberly Drive
        <br />
        Suite 250
        <br />
        Tampa, FL 33647
      </div>
    </Box>
  );
}
